/** Clé sessionStorage : organisation cible avant redirection OAuth Google. */
export const U3201_GOOGLE_CALENDAR_OAUTH_RETURN_ORG_ID_KEY = "u3201_google_calendar_oauth_return_org_id";
/** Clé sessionStorage : UL de retour (U2104 | U3148). */
export const U3201_GOOGLE_CALENDAR_OAUTH_RETURN_LU_KEY = "u3201_google_calendar_oauth_return_lu";

export type U3201GoogleCalendarOAuthReturnLu = "U2104" | "U3148";

/** URL de retour frontend après consentement Google — fiche U2104 de l'organisation. */
export function buildU2104GoogleCalendarOAuthFrontendRedirectUrl(orgId: string): string {
  const base = window.location.origin.replace(/\/$/, "");
  return `${base}/U2104/${orgId}`;
}

/** URL de retour frontend après consentement Google — fiche U3148 (mon organisation). */
export function buildU3148GoogleCalendarOAuthFrontendRedirectUrl(orgId: string): string {
  const base = window.location.origin.replace(/\/$/, "");
  return `${base}/U3148/${orgId}`;
}

export function isGenericFrontendOriginUrl(url: string): boolean {
  const trimmed = url.trim().replace(/\/$/, "");
  if (!trimmed) return true;
  const origin = window.location.origin.replace(/\/$/, "");
  return trimmed === origin;
}

export function storeGoogleCalendarOAuthReturnOrgId(orgId: string, logicalUnit: U3201GoogleCalendarOAuthReturnLu = "U2104"): void {
  sessionStorage.setItem(U3201_GOOGLE_CALENDAR_OAUTH_RETURN_ORG_ID_KEY, orgId);
  sessionStorage.setItem(U3201_GOOGLE_CALENDAR_OAUTH_RETURN_LU_KEY, logicalUnit);
}

export function consumeGoogleCalendarOAuthReturnOrgId(): string | null {
  const orgId = sessionStorage.getItem(U3201_GOOGLE_CALENDAR_OAUTH_RETURN_ORG_ID_KEY);
  if (orgId) {
    sessionStorage.removeItem(U3201_GOOGLE_CALENDAR_OAUTH_RETURN_ORG_ID_KEY);
  }
  return orgId;
}

export function consumeGoogleCalendarOAuthReturnLu(): U3201GoogleCalendarOAuthReturnLu {
  const lu = sessionStorage.getItem(U3201_GOOGLE_CALENDAR_OAUTH_RETURN_LU_KEY);
  sessionStorage.removeItem(U3201_GOOGLE_CALENDAR_OAUTH_RETURN_LU_KEY);
  return lu === "U3148" ? "U3148" : "U2104";
}
